import { QuoteItemStatusTypes } from '@/enums'

export default {
  methods: {
    // Soft-delete an already-synced item locally; the debounced autosave PUTs it as deleted.
    autoSaveDeleteExistingItem(item) {
      item.deleted = true
      item.isDeleted = true
      item.itemStatus = QuoteItemStatusTypes.Deleted
    }
  }
}
